import React from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useNavigate } from "react-router-dom";

const Breadcrumb = (props) => {
  const { title, returnPage = "/", theme = "white" } = props || {};
  const navigate = useNavigate();

  const navigateHandler = () => {
    if (returnPage === "/back") {
      navigate(-1);
    } else {
      navigate(returnPage);
    }
  };

  return (
    <div className={`breadcrumb-content ${theme}`}>
      <KeyboardArrowLeftIcon onClick={navigateHandler} />
      <span>{title}</span>
    </div>
  );
};

export default Breadcrumb;
